import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getStudentGoals = ({ studentId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/goals/all/${studentId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCareerGoal = ({ studentId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/goals/career/${studentId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateStudentGoal = ({ goalType, payload, version = 'v1' }) =>
  client
    .request({
      url: `${version}/goals/${goalType}/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentHistory = ({ studentId, version = 'v1', params }) =>
  client
    .request({
      url: `${version}/goals/history/${studentId ? `${studentId}/` : ''}`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
